import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/LoadingState/LoadingState.tsx
import { useReportLoading } from "../../../hooks/useLoadingActivity.mjs";
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
import { Spinner } from "../Spinner/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function LoadingState({
  ref,
  className,
  ...rest
}) {
  const { t } = useComponentsTranslation();
  useReportLoading();
  return /* @__PURE__ */ jsxs("div", { ref, className: className ? `buyscout-loading-state ${className}` : "buyscout-loading-state", role: "status", ...rest, children: [
    /* @__PURE__ */ jsx(Spinner, { size: "lg", "aria-hidden": true }),
    /* @__PURE__ */ jsx("p", { className: "buyscout-loading-state__label", children: t("loadingState.loading") })
  ] });
}
LoadingState.displayName = "LoadingState";
export {
  LoadingState
};
//# sourceMappingURL=LoadingState.mjs.map